import {
  Companion_getInstancee6k6ib2dkotb as Companion_getInstance,
  License2dabzwgw7jcr2 as License,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  State3dw676r1r3e8w as State,
  LicenseType3s47gtt1wni19 as LicenseType,
} from './enums.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_number(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_number_getInstance());
}
function get_city(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_city_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_state_getInstance());
}
function get_type(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_type_getInstance());
}
function get_file(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_file_getInstance());
}
function get_preview(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_preview_getInstance());
}
function get_fileType(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_fileType_getInstance());
}
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(License_contractor_getInstance());
}
function prepareLicenseFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [License__id_getInstance(), License_contractor_getInstance(), License_number_getInstance(), License_city_getInstance(), License_state_getInstance(), License_file_getInstance(), License_fileType_getInstance(), License_preview_getInstance(), License_type_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function License_number$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function License_number$_get_name_$ref_h768k4() {
  return (p0) => p0.i20();
}
function License_number$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_number$_get_serializer_$ref_e820at() {
  return (p0) => p0.h2j();
}
function License_number$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function License_number$_get_annotations_$ref_1cn529() {
  return (p0) => p0.bz();
}
var License_numberClass;
function License_number() {
  if (License_numberClass === VOID) {
    class $ {
      constructor() {
        License_number_instance = this;
        var tmp = this;
        tmp.q6e_1 = lazy(License_number$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r6e_1 = lazy(License_number$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s6e_1 = lazy(License_number$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.q6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_number$_get_name_$ref_h768k4(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.w6e_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      d6f(receiver, value) {
        return receiver.e6f(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.d6f(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_number$_get_serializer_$ref_e820at(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_number$_get_annotations_$ref_1cn529(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_number', VOID, VOID, [SerializableProperty()]);
    License_numberClass = $;
  }
  return License_numberClass;
}
var License_number_instance;
function License_number_getInstance() {
  if (License_number_instance === VOID)
    new (License_number())();
  return License_number_instance;
}
function License_city$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function License_city$_get_name_$ref_a6im2y() {
  return (p0) => p0.i20();
}
function License_city$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_city$_get_serializer_$ref_nchx2b() {
  return (p0) => p0.h2j();
}
function License_city$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function License_city$_get_annotations_$ref_2ne5a7() {
  return (p0) => p0.bz();
}
var License_cityClass;
function License_city() {
  if (License_cityClass === VOID) {
    class $ {
      constructor() {
        License_city_instance = this;
        var tmp = this;
        tmp.f6f_1 = lazy(License_city$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6f_1 = lazy(License_city$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6f_1 = lazy(License_city$annotations$delegate$lambda);
        this.i6f_1 = null;
        this.j6f_1 = 'null';
      }
      i20() {
        var tmp0 = this.f6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_city$_get_name_$ref_a6im2y(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.x6e_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      k6f(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.k6f(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_city$_get_serializer_$ref_nchx2b(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_city$_get_annotations_$ref_2ne5a7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_city', VOID, VOID, [SerializableProperty()]);
    License_cityClass = $;
  }
  return License_cityClass;
}
var License_city_instance;
function License_city_getInstance() {
  if (License_city_instance === VOID)
    new (License_city())();
  return License_city_instance;
}
function License_state$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function License_state$_get_name_$ref_gtvj1c() {
  return (p0) => p0.i20();
}
function License_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_state$_get_serializer_$ref_vft8p3() {
  return (p0) => p0.h2j();
}
function License_state$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function License_state$_get_annotations_$ref_3pp7jf() {
  return (p0) => p0.bz();
}
var License_stateClass;
function License_state() {
  if (License_stateClass === VOID) {
    class $ {
      constructor() {
        License_state_instance = this;
        var tmp = this;
        tmp.l6f_1 = lazy(License_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6f_1 = lazy(License_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6f_1 = lazy(License_state$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_state$_get_name_$ref_gtvj1c(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.y6e_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      o6f(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.o6f(tmp, value instanceof State() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_state$_get_serializer_$ref_vft8p3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_state$_get_annotations_$ref_3pp7jf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_state', VOID, VOID, [SerializableProperty()]);
    License_stateClass = $;
  }
  return License_stateClass;
}
var License_state_instance;
function License_state_getInstance() {
  if (License_state_instance === VOID)
    new (License_state())();
  return License_state_instance;
}
function License_type$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function License_type$_get_name_$ref_eg5xgb() {
  return (p0) => p0.i20();
}
function License_type$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_type$_get_serializer_$ref_ddq4ok() {
  return (p0) => p0.h2j();
}
function License_type$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function License_type$_get_annotations_$ref_rgvd80() {
  return (p0) => p0.bz();
}
var License_typeClass;
function License_type() {
  if (License_typeClass === VOID) {
    class $ {
      constructor() {
        License_type_instance = this;
        var tmp = this;
        tmp.p6f_1 = lazy(License_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q6f_1 = lazy(License_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r6f_1 = lazy(License_type$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.p6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_type$_get_name_$ref_eg5xgb(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.c6f_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      s6f(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.s6f(tmp, value instanceof LicenseType() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_type$_get_serializer_$ref_ddq4ok(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_type$_get_annotations_$ref_rgvd80(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_type', VOID, VOID, [SerializableProperty()]);
    License_typeClass = $;
  }
  return License_typeClass;
}
var License_type_instance;
function License_type_getInstance() {
  if (License_type_instance === VOID)
    new (License_type())();
  return License_type_instance;
}
function License_file$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function License_file$_get_name_$ref_t4o6c9() {
  return (p0) => p0.i20();
}
function License_file$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_file$_get_serializer_$ref_3izktu() {
  return (p0) => p0.h2j();
}
function License_file$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function License_file$_get_annotations_$ref_m7tt76() {
  return (p0) => p0.bz();
}
var License_fileClass;
function License_file() {
  if (License_fileClass === VOID) {
    class $ {
      constructor() {
        License_file_instance = this;
        var tmp = this;
        tmp.t6f_1 = lazy(License_file$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6f_1 = lazy(License_file$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6f_1 = lazy(License_file$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.t6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_file$_get_name_$ref_t4o6c9(), null);
        return tmp0.f2();
      }
      w6f(receiver) {
        return receiver.z6e_1;
      }
      k2j(receiver) {
        return new (ServerFile())(this.w6f(receiver instanceof License() ? receiver : THROW_CCE()));
      }
      x6f(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.x6f(tmp, value instanceof ServerFile() ? value.l2n_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_file$_get_serializer_$ref_3izktu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_file$_get_annotations_$ref_m7tt76(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_file', VOID, VOID, [SerializableProperty()]);
    License_fileClass = $;
  }
  return License_fileClass;
}
var License_file_instance;
function License_file_getInstance() {
  if (License_file_instance === VOID)
    new (License_file())();
  return License_file_instance;
}
function License_preview$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function License_preview$_get_name_$ref_gh43t5() {
  return (p0) => p0.i20();
}
function License_preview$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_preview$_get_serializer_$ref_2vld9e() {
  return (p0) => p0.h2j();
}
function License_preview$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function License_preview$_get_annotations_$ref_22lale() {
  return (p0) => p0.bz();
}
var License_previewClass;
function License_preview() {
  if (License_previewClass === VOID) {
    class $ {
      constructor() {
        License_preview_instance = this;
        var tmp = this;
        tmp.y6f_1 = lazy(License_preview$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z6f_1 = lazy(License_preview$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a6g_1 = lazy(License_preview$annotations$delegate$lambda);
        this.b6g_1 = null;
        this.c6g_1 = 'null';
      }
      i20() {
        var tmp0 = this.y6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_preview$_get_name_$ref_gh43t5(), null);
        return tmp0.f2();
      }
      d6g(receiver) {
        return receiver.b6f_1;
      }
      k2j(receiver) {
        var tmp = this.d6g(receiver instanceof License() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      e6g(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.l2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.e6g(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.z6f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_preview$_get_serializer_$ref_2vld9e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_preview$_get_annotations_$ref_22lale(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_preview', VOID, VOID, [SerializableProperty()]);
    License_previewClass = $;
  }
  return License_previewClass;
}
var License_preview_instance;
function License_preview_getInstance() {
  if (License_preview_instance === VOID)
    new (License_preview())();
  return License_preview_instance;
}
function License_fileType$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function License_fileType$_get_name_$ref_1p8kn5() {
  return (p0) => p0.i20();
}
function License_fileType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_fileType$_get_serializer_$ref_bg2ivs() {
  return (p0) => p0.h2j();
}
function License_fileType$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function License_fileType$_get_annotations_$ref_gf3310() {
  return (p0) => p0.bz();
}
var License_fileTypeClass;
function License_fileType() {
  if (License_fileTypeClass === VOID) {
    class $ {
      constructor() {
        License_fileType_instance = this;
        var tmp = this;
        tmp.f6g_1 = lazy(License_fileType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6g_1 = lazy(License_fileType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6g_1 = lazy(License_fileType$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.f6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_fileType$_get_name_$ref_1p8kn5(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.a6f_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      d6f(receiver, value) {
        return receiver.e6f(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.d6f(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_fileType$_get_serializer_$ref_bg2ivs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_fileType$_get_annotations_$ref_gf3310(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_fileType', VOID, VOID, [SerializableProperty()]);
    License_fileTypeClass = $;
  }
  return License_fileTypeClass;
}
var License_fileType_instance;
function License_fileType_getInstance() {
  if (License_fileType_instance === VOID)
    new (License_fileType())();
  return License_fileType_instance;
}
function License_contractor$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function License_contractor$_get_name_$ref_ly1aio() {
  return (p0) => p0.i20();
}
function License_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License_contractor$_get_serializer_$ref_sp70dj() {
  return (p0) => p0.h2j();
}
function License_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function License_contractor$_get_annotations_$ref_hlqbij() {
  return (p0) => p0.bz();
}
var License_contractorClass;
function License_contractor() {
  if (License_contractorClass === VOID) {
    class $ {
      constructor() {
        License_contractor_instance = this;
        var tmp = this;
        tmp.i6g_1 = lazy(License_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j6g_1 = lazy(License_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k6g_1 = lazy(License_contractor$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.i6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License_contractor$_get_name_$ref_ly1aio(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.v6e_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      l6g(receiver, value) {
        return receiver.e6f(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.l6g(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License_contractor$_get_serializer_$ref_sp70dj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License_contractor$_get_annotations_$ref_hlqbij(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License_contractor', VOID, VOID, [SerializableProperty()]);
    License_contractorClass = $;
  }
  return License_contractorClass;
}
var License_contractor_instance;
function License_contractor_getInstance() {
  if (License_contractor_instance === VOID)
    new (License_contractor())();
  return License_contractor_instance;
}
function License__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function License__id$_get_name_$ref_4suq6v() {
  return (p0) => p0.i20();
}
function License__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function License__id$_get_serializer_$ref_5z689c() {
  return (p0) => p0.h2j();
}
function License__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function License__id$_get_annotations_$ref_bp9zdg() {
  return (p0) => p0.bz();
}
var License__idClass;
function License__id() {
  if (License__idClass === VOID) {
    class $ {
      constructor() {
        License__id_instance = this;
        var tmp = this;
        tmp.m6g_1 = lazy(License__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n6g_1 = lazy(License__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o6g_1 = lazy(License__id$annotations$delegate$lambda);
        this.p6g_1 = Companion_getInstance_0().k2p();
        this.q6g_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.m6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, License__id$_get_name_$ref_4suq6v(), null);
        return tmp0.f2();
      }
      t6e(receiver) {
        return receiver.u6e_1;
      }
      k2j(receiver) {
        return this.t6e(receiver instanceof License() ? receiver : THROW_CCE());
      }
      l6g(receiver, value) {
        return receiver.e6f(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof License() ? receiver : THROW_CCE();
        return this.l6g(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, License__id$_get_serializer_$ref_5z689c(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o6g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, License__id$_get_annotations_$ref_bp9zdg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'License__id', VOID, VOID, [SerializableProperty()]);
    License__idClass = $;
  }
  return License__idClass;
}
var License__id_instance;
function License__id_getInstance() {
  if (License__id_instance === VOID)
    new (License__id())();
  return License__id_instance;
}
//region block: exports
export {
  get_city as get_city1bjg5zekkdtgv,
  get_contractor as get_contractor3k6krm423825t,
  get_file as get_file34qr2ah8a6n2l,
  get_fileType as get_fileTypeygrn13ooccjs,
  get_number as get_number12xa0a80pfu1s,
  prepareLicenseFields as prepareLicenseFieldsqamx9w9g5tiv,
  get_preview as get_preview30bi6nssrxjqo,
  get_state as get_state1oz04fp2krbaq,
  get_type as get_type2gglctwv6p9gt,
};
//endregion

//# sourceMappingURL=LicenseFields.mjs.map
